import PosActions from '../../actions/PosActions';
import NotificationActions from '../../actions/NotificationActions';
import GuestListActions from '../../actions/GuestListActions';
import Cookies from 'universal-cookie';
import PosStore from '../../stores/PosStore';
import UserStore from '../../stores/UserStore';
import ConfigStore from '../../stores/ConfigStore';
import GuestListStore from '../../stores/GuestListStore';
import PermissionStore from '../../stores/PermissionStore';
import { Permissions } from '../../constants/PermissionConstants';

import Input from '../form/input/Input.react';
import PageHeader from '../form/layout/PageHeader.react';
import PageRow from '../form/layout/PageRow.react';

import DD from '../form/dropdown/DD.react';
import DDBoolean from '../form/dropdown/DDBoolean.react';
import AjaxPromises from '../../utils/AjaxPromises';
import StatusComponent from '../status/StatusComponent.react';
import StatusPage from '../status/StatusPage.react';

class GLSettings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible           : false,
            autoPrintLabels   : PosStore.getState().autoPrintLabels,
            labels            : PosStore.getState().labels,
            availableReceiptPrinters : PosStore.getState().availableReceiptPrinters || [],
            availableLabelPrinters   : PosStore.getState().availableLabelPrinters || [],
            receiptPrinter    : false,
            defaultLabel      : PosStore.getState().defaultLabel,
            autoPrintReceipts : PosStore.getState().autoPrintReceipts,
            popUpNotes        : PosStore.getState().popUpNotes,
            usePrintNode      : PosStore.getState().usePrintNode,
            showSearchBar     : GuestListStore.getState().showSearchBar,
            showGuestAssignedToRegister : GuestListStore.getState().showGuestAssignedToRegister,
            registers: [],
            assignedRegisterId: '',
            selectedRegisterId: ''
        };

        this.onPosStoreChange = this.onPosStoreChange.bind(this);
        this.onGuestListStoreChange = this.onGuestListStoreChange.bind(this);
        this.loadRegisters = this.loadRegisters.bind(this);
        this.saveAssignedRegister = this.saveAssignedRegister.bind(this);
    }

    componentWillMount() {
        PosStore.addChangeListener(this.onPosStoreChange);
        GuestListStore.addChangeListener(this.onGuestListStoreChange);
    }

    componentDidMount() {
        this.onPosStoreChange();
        this.loadRegisters();
    }

    componentWillUnmount() {
        PosStore.removeChangeListener(this.onPosStoreChange);
        GuestListStore.removeChangeListener(this.onGuestListStoreChange);
    }

    onPosStoreChange() {
        this.setState({
            autoPrintLabels   : PosStore.getState().autoPrintLabels,
            labels            : PosStore.getState().labels,
            defaultLabel      : PosStore.getState().defaultLabel,
            autoPrintReceipts : PosStore.getState().autoPrintReceipts,
            popUpNotes        : PosStore.getState().popUpNotes,
            receiptPrinter    : PosStore.getState().receiptPrinter.PrinterId,
            usePrintNode      : PosStore.getState().usePrintNode,
            availableReceiptPrinters   : PosStore.getState().availableReceiptPrinters || [],
            receiptPrinter    : PosStore.getState().receiptPrinter.PrinterId,
            availableLabelPrinters     : PosStore.getState().availableLabelPrinters || [],
            labelPrinter      : PosStore.getState().labelPrinter.PrinterId,
        });
    }

    loadRegisters() {
        AjaxPromises.POST('api/posv3/registers/get-all', UserStore.getApiData()).then(resp => {
            if(resp.Result) {
                var cookies = new Cookies();
                var hardwareData = cookies.get('LeafLogixHardwareData', { path: '/' });
                var hardwareId = (hardwareData || {}).hardwareId

                var assignedRegister = _.find(resp.Data, r => r.HardwareId === hardwareId);

                this.setState({
                    registers: resp.Data,
                    assignedRegisterId: assignedRegister ? assignedRegister.Id : '',
                    selectedRegisterId: assignedRegister ? assignedRegister.Id : ''
                })
            }
        });        
    }

    saveAssignedRegister() {
        PosActions.assignRegister({
            registerId: this.state.selectedRegisterId
        }).then(x => {
            this.loadRegisters();
        });
    }

    onGuestListStoreChange() {
        this.setState({
            showSearchBar     : GuestListStore.getState().showSearchBar,
            showGuestAssignedToRegister : GuestListStore.getState().showGuestAssignedToRegister,
        });
    }

    openCartDisplay() {
        if(!!UserStore.getApiData().Register) {
            window.open(`cart-display-${UserStore.getApiData().Register}-${UserStore.getApiData().LocId}`, 'popUpWindow','height=700,width=1050,left=200,top=200,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
        } else {
            NotificationActions.error('Please select a register to display first');
        }
    }

    render() {
        var self = this,
            page = this.props.page,
            user = this.props.user,
            selectedLocation = this.props.selectedLocation;

        if (page !== 'settings')
            return null;

        var autoPrintReceipts = this.state.autoPrintReceipts;
        var popUpNotes        = this.state.popUpNotes;

        var labelArr = ([{ title: '-', option: '0' }].concat(this.state.labels))
            .map(p => { return { title: p.LabelDescription, option: p.id }});

        var labelPrinters = ([{ Name: '' }].concat(this.state.availableLabelPrinters))
            .map(p => { return { title: p.Name, option: p.PrinterId }});

        var receiptPrinters = ([{Name: ''}]).concat(this.state.availableReceiptPrinters)
            .map(p => { return { title: p.Name, option: p.PrinterId }});

        var registers = _.map([{ TerminalName: '-', Id: '' }].concat(this.state.registers || []), r => ({ title: r.TerminalName, option: r.Id }));

        var showHardware = (selectedLocation.AssignRegistersToHardware && PermissionStore.userCan(Permissions.POSManager));

        return (
            <div className='settings'>
                <div className='container'>
                    {
                    showHardware &&
                    <div>
                        <PageHeader title='Hardware' />
                        <PageRow title='Assigned Register'>
                            <DD
                                value={this.state.selectedRegisterId}
                                options={registers}
                                onChange={selectedRegisterId => { this.setState({ selectedRegisterId }) }} />
                            {
                                this.state.assignedRegisterId !== this.state.selectedRegisterId &&
                                <button className='btn-green' onClick={this.saveAssignedRegister}>Save</button>
                            }
                        </PageRow>                    
                    </div>
                    }

                    <PageHeader title='Labels' />

                    <PageRow title='Auto Print Labels'>
                        <DDBoolean
                            value={this.state.autoPrintLabels}
                            onChange={val => {
                                if (this.state.defaultLabel === '-')
                                    NotificationActions.alert('Please select default label');
                                else
                                    PosActions.setAutoPrintLabels(val);
                            }} />
                    </PageRow>

                    <PageRow title='Default Label'>
                        <DD
                            value={this.state.defaultLabel}
                            options={labelArr}
                            onChange={val => { PosActions.setDefaultLabel(val); }} />
                    </PageRow>

                    
                    <PageRow title='Default Label Printer'>
                        <DD
                            value={this.state.labelPrinter}
                            options={labelPrinters}
                            onChange={val => { PosActions.setLabelPrinter(val); }} />
                    </PageRow>
                    

                    <PageHeader title='Receipts' />

                    <PageRow title='Auto Print Receipts'>
                        <DDBoolean
                            value={this.state.autoPrintReceipts}
                            label={['On', 'Off']}
                            onChange={val => { PosActions.setAutoPrintReceipts(val); }} />
                    </PageRow>

                    
                    <PageRow title='Receipt Printer'>
                        <DD
                            value={this.state.receiptPrinter}
                            options={receiptPrinters}
                            onChange={val => { PosActions.setReceiptPrinter(val); }} />
                    </PageRow>
                    

                    <PageHeader title='Other' />

                    <PageRow title='Popup Notes when entering POS'>
                        <DDBoolean
                            value={this.state.popUpNotes}
                            label={['Show', 'Hide']}
                            onChange={val => { PosActions.popUpNotes(val); }} />
                    </PageRow>

                    <PageRow title='Show search in guest list'>
                        <DDBoolean
                            value={this.state.showSearchBar}
                            label={['Show', 'Hide']}
                            onChange={val => { GuestListActions.toggleSearchBar(val); }} />
                    </PageRow>

                    <PageRow title='Show Guests assigned to register'>
                        <DDBoolean
                            value={this.state.showGuestAssignedToRegister}
                            label={['Show', 'Hide']}
                            onChange={val => { GuestListActions.toggleGuestAssignedToRegister(val); }} />
                    </PageRow>

                    { selectedLocation.UseCartDisplay &&
                    <PageRow title='Open Cart Display'>
                        <button className='btn-green' onClick={this.openCartDisplay}>Open Display</button>
                    </PageRow>
                    }
                    
                </div>
            </div>
        );
    }
}

export default GLSettings;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLSettings.react.jsx